import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setSelectedBan } from '../OwnershipTransferSlice';
import SelectOptionButton from '../../../Shared/SelectOptionButton/SelectOptionButton';
import { OwnershipTransferStep } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const BanSelecting = (props) => {
  const [error, setError] = useState(false);
  const [banListForSelect, setBanListForSelect] = useState([]);

  useEffect(() => {
    if (props.data.banList?.length > 0) {
      getBanListForSelect();
    }
  }, [props.data.banList]);

  function getBanListForSelect() {
    if (props.data.banList?.length > 0) {
      props.data.banList.map((ban, index) => {
        const selected = props.data.selectedBan == ban.banNumber ? true : false;
        const item = {
          id: index,
          label: `מספר לקוח | ${ban.banNumber} `,
          rightContent: ban.banBusinessName,
          value: ban.banNumber,
          selected: selected,
        };
        setBanListForSelect((oldArray) => [...oldArray, item]);
      });
    }
  }

  function nextStep() {
    if (!props.data.selectedBan) {
      setError(true);
    } else {
      props.setCurrentStep(OwnershipTransferStep.CustomerForm);
    }
  }

  return (
    <div className='ownership-transfer-select-ban-step  ownership-transfer-step'>
      {banListForSelect.length > 0 && (
        <div>
          <div className=''>
            <div className='l-title '>מה מספר הלקוח אליו ישוייך הקו?</div>

            <div className={`ownership-transfer-select-ban ${banListForSelect?.length > 6 ? 'scroll' : ''}`}>
              <SelectOptionButton buttonsData={banListForSelect} onClick={props.setSelectedBan} />
            </div>
          </div>
          <div className='continue-button'>
            {error && <div className='error center'>כדי להמשיך יש לבחור את מספר הלקוח</div>}
            <BtnSubmit onclick={nextStep} text={'בחרתי, אפשר להמשיך'} />
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedBan,
};

export default connect(mapStateToProps, mapDispatchToProps)(BanSelecting);
